import { useEffect, useCallback } from 'react';
import { cn } from '@/lib/utils';

interface DrawerChatLayoutProps {
  children: React.ReactNode;
  onClose: () => void;
  className?: string;
}

export function DrawerChatLayout({ children, onClose, className }: DrawerChatLayoutProps) {
  const handleKeyDown = useCallback((e: KeyboardEvent) => {
    if (e.key === 'Escape') onClose();
  }, [onClose]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/20" onClick={onClose} />
      {/* Drawer */}
      <div
        className={cn(
          'relative w-full md:w-[480px] h-full bg-background shadow-xl animate-in slide-in-from-right duration-300',
          className
        )}
      >
        {children}
      </div>
    </div>
  );
}
